import { BirdviewCommunicationKind } from '../DashboardBirdview.constants'

import { BIRDVIEW_COMMUNICATION_ROW_KIND } from './BirdviewCommunicationRow.constants'

export function getBirdviewCommunicationRowKind(kind) {
  return (
    BIRDVIEW_COMMUNICATION_ROW_KIND[kind] ??
    BIRDVIEW_COMMUNICATION_ROW_KIND[BirdviewCommunicationKind.Email]
  )
}
